import { useEffect, useState } from "react";
import "../../App.css";
import "./Menu3.css";
import { useNavigate } from "react-router-dom";
import { CarrionCategory3 } from "../CarruselCategorias/CarrionCategory3";
import { Header3 } from "../header/Header3";
import { MenuListAlternativo3 } from "../../componentes/MenuListAlternativoHome/MenuListAlternativo3";
import { apiGet } from '../../utils/api';
import { configShop } from '../../states/configShop';
import Modal from "../Modal/modal";
import useWindowWidth from "../hooks/useMediaQuery";
import AddressAdd from "../Address/AddressAdd";
import ShopAdd from "../Address/ShopAdd";
import { userOrder } from '../../states/userOrder';
import { useLocation } from "react-router-dom";
import { CarrionGroup } from "../../componentes/CarruselCategorias/CarrionGroup";
import { ToastContainer } from 'react-toastify';
import PopupNew from "../../componentes/Popup/PopupNew";
import { useLocalStorageExpire } from "../hooks/useLocalStorageExpire";
import PopUpProgramarNew2 from "../DetallePago/PopUpProgramarNew2";
import { FaShoppingCart, FaChevronRight } from "react-icons/fa";
export const Menu3 = () => {
    const location = useLocation();
    const url = window.location.origin + location.pathname;
    const { dataConfig } = configShop();
    const { dataUser } = userOrder();
    const [popupStatus, setPopupStatus] = useLocalStorageExpire('CloseShop', true, 10);
    const width = useWindowWidth()
    let navigate = useNavigate();
    const [openCategories, setOpenCategories] = useState([]);
    const [openPopUp, setOpenPopUp] = useState({});
    const [popUp, setPopUp] = useState([]);
    const [openShop, setOpenShop] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [CloseShopModal, setCloseShopModal] = useState(true);
    const [propiedadesCompany, setPropiedadesCompany] = useState([]);
    const [nConfig, setNconfig] = useState({});
    const [groups, setGroups] = useState([]);
    // aqui se guarda el color del boton azul
    const [visibleCart, setVisibleCart] = useState(false);
    const obtenerPrecioProducto = (producto) => {
        var precioTopping = 0;
        if (producto.toppings !== undefined) {
            producto.toppings.map((item) => {
                if (item.topingsSeleccionados !== undefined) {
                    item.topingsSeleccionados.map((topping) => {
                        precioTopping = precioTopping + topping.price;
                    });
                }
            });
        }
        var precioTotal = producto.precio + precioTopping;
        precioTotal = precioTotal * producto.cantidadProducto;
        return precioTotal;
    };
    ///
    const [precioTotal, setPrecioTotal] = useState(0);

    const [cantidadItems, setCantidadItems] = useState(0);

    const obtenerProductos = () => {
        const informacionLocalStorage = localStorage.getItem(
            "infoProductoSeleccionado"
        );

        if (
            informacionLocalStorage !== undefined &&
            informacionLocalStorage !== null
        ) {
            let parsedRespuesta = JSON.parse(informacionLocalStorage);
            var precioTotal = 0;
            var cantidad = 0;
            parsedRespuesta.map((item) => {
                precioTotal += obtenerPrecioProducto(item);
                cantidad += item.cantidadProducto ?? 1;
            });
            setPrecioTotal(precioTotal);
            setCantidadItems(cantidad);
            setVisibleCart(true);
        } else {
            setVisibleCart(false);
        }
    };
    ////
    const [popUpFechaEntrega, setpopUpFechaEntrega] = useState(false);

    ////
    const pleiztUuids = window.location.hostname.split(".")[0];

    var pleiztUuid;
    if (pleiztUuids === undefined) {
        if (localStorage.getItem("pleiztUuid") === undefined) {
        } else {
            pleiztUuid = localStorage.getItem("pleiztUuid");
        }
    } else {
        pleiztUuid = pleiztUuids;
        if (localStorage.getItem("pleiztUuid") !== pleiztUuid) {
            localStorage.clear();
        }
        localStorage.setItem("pleiztUuid", pleiztUuid);
    }
    const urlHome = '';
    const codigoPais = "es-CO";
    const codigoCurrency = "COP";
    useEffect(() => {
        localStorage.setItem("typeSend", 0);
        setOpenModal(dataUser.popAddress);
        (async function () {
            const res = await apiGet('/home-new-3');
            var mensajeExito = res.success;
            if (mensajeExito === "success") {
                setOpenCategories(res?.data?.categories); // aqui estoy pasando el objeto categories, no es necesario pasarlo en el map.
                setOpenPopUp(res.data.popup);
                setPropiedadesCompany(res.properties);
                setNconfig(res.data.config)
                setGroups(res.data.groups);
                setPopUp(res.properties.popUps?.popupMenu);
            } else {
                console.log("No hay menus para este restaurante");
            }
        })();
        obtenerProductos();
    }, [urlHome]);

    useEffect(() => {
        const pageMenu = propiedadesCompany?.page_menu;
        if (pageMenu?.background_type == "1") {
            document.body.style.backgroundColor = pageMenu.color_background;
            document.body.style.backgroundImage = "";
        } else if (pageMenu?.background_type == "2") {
            document.body.style.backgroundImage = `url(${pageMenu.background_image})`;
            document.body.style.backgroundSize = "auto";
            document.body.style.backgroundPosition = "center";
            document.body.style.backgroundColor = "";
        }
        return () => {
            document.body.style.backgroundColor = "";
            document.body.style.backgroundImage = "";
        };
    }, [propiedadesCompany]);
    /////
    const handleShare = async () => {
        try {
            await navigator.share({
                title: dataConfig?.title_home,
                text: dataConfig?.description_home,
                url: url,
            });
        } catch (err) {
            console.log("Compartir cancelado o no soportado", err);
        }
    };
    ////
    const [search, setSearch] = useState("");
    const filteredProducts = openCategories?.map(category => ({
        ...category,
        items: category.items.filter(item =>
            item.name.toLowerCase().includes(search.toLowerCase()) ||
            item.description.toLowerCase().includes(search.toLowerCase())
        )
    }))
        .filter(category => category.items.length > 0);
    return (
        <div className="App container justify-content-center align-items-center">
            <header className="App-header" >
                <Header3 propiedadesCompany={propiedadesCompany} configHeader={nConfig} />
            </header>
            <PopupNew TimeMoments={'PopUpMenu'} popUps={popUp} />

            <CarrionCategory3
                openCategories={openCategories}
                setSearch={setSearch}
                search={search}
            />
            {groups?.map((group, i) => {
                return (
                    <CarrionGroup openCategories={group.items} title={group.name} image={group.image} />
                );
            })}
            {filteredProducts?.map((item, i) => {
                return (
                    <section id={item.uuid} className="menu-3-section color-text" style={{ "--btn-font-color": dataConfig?.page_menu?.color_text }}>
                        {item.is_photo
                            ? <img
                                src={item.photo}
                                alt="fotoComida"
                                style={{
                                    maxWidth: "100%",
                                    marginBottom: "10px",
                                    borderRadius: "7px",
                                    objectFit: "cover",
                                }}
                            ></img>
                            : <h2 className="h4">{item.name}</h2>
                        }
                        <MenuListAlternativo3
                            categoriaSeleccionada={item.items}
                            codigoCurrency={codigoCurrency}
                            codigoPais={codigoPais}
                            productoFiltrado={null}
                        />
                    </section>
                )
            })}
            {visibleCart && (
                <div style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    background: "transparent",
                    padding: "12px 16px 20px",
                    zIndex: 1000,
                }}>
                    <button
                        onClick={() => navigate("/shoppingCart/")}
                        style={{
                            width: "100%",
                            background: dataConfig?.page_menu?.button?.color ?? "#000",
                            color: dataConfig?.page_menu?.button?.color_text ?? "#fff",
                            border: "none",
                            borderRadius: "14px",
                            padding: "14px 20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.22)",
                            cursor: "pointer",
                        }}
                    >
                        {/* Izquierda: icono + badge */}
                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                            <FaShoppingCart size={22} />
                            <span style={{
                                position: "absolute",
                                top: "-8px",
                                right: "-10px",
                                background: dataConfig?.page_menu?.button?.color_text ?? "#fff",
                                color: dataConfig?.page_menu?.button?.color ?? "#000",
                                borderRadius: "50%",
                                width: "18px",
                                height: "18px",
                                fontSize: "11px",
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                lineHeight: 1,
                            }}>
                                {cantidadItems}
                            </span>
                        </div>

                        {/* Centro: CTA */}
                        <span style={{ fontSize: "16px", fontWeight: 700, letterSpacing: "0.3px" }}>
                            Ver mi pedido
                        </span>

                        {/* Derecha: precio */}
                        <span style={{ fontSize: "16px", fontWeight: 700 }}>
                            {precioTotal.toLocaleString(codigoPais, {
                                style: "currency",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                currency: codigoCurrency,
                            })}
                        </span>
                    </button>
                </div>
            )}

            <ToastContainer />
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openModal}
                title={"Datos de entrega."}
                zIndexs={10}
            >
                {dataUser.deliveryMethod == 1 ? (
                    <AddressAdd
                        setOpenModal={setOpenModal}
                    />
                ) : (<ShopAdd
                    setOpenModal={setOpenModal}
                />)}

            </Modal>           
        </div>

    );
};
export default Menu3;
